var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Nav',{on:{"change-locale":_vm.changeLocale}}),_c('transition',{attrs:{"name":"fade","mode":"in"}},[_c('router-view',{on:{"change-locale":_vm.changeLocale}})],1),_c('Footer'),_c('LeftLayout'),_c('RightLayout'),_c('ButtonRed')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }